<template>
<Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="row title-row">
                        <div class="col-xl-6 col-lg-6 col-md-6">
                            <h4 class="card-title mb-4">Staking List</h4>
                        </div>
                    </div>

                    <simplebar style="max-height: 600px">
                        <div class="table-responsive">
                            <b-table :items="myProvider" :fields="fields" responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :busy="loading" ref="table" show-empty>
                                <template #empty>
                                    <div class="d-flex justify-content-center mb-3">
                                        No Record Found
                                    </div>
                                </template>

                                <template #table-busy>
                                    <div class="text-center text-info my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                    </div>
                                </template>

                                <template #cell(SR_NO)="data">
                                    {{ data.index + 1 }}
                                </template>

                                <template v-slot:cell(title)="data">
                                    <div v-if="data.item.title">
                                        {{ data.item.title }}
                                    </div>
                                    <div v-else>-
                                    </div>
                                </template>

                                <template v-slot:cell(description)="data">
                                    <div v-if="data.item.description">
                                        {{ data.item.description }}
                                    </div>
                                    <div v-else>-
                                    </div>
                                </template>

                                <template v-slot:cell(stake_currency)="data">
                                    <div v-if="data.item.stake_currency">
                                        {{ data.item.stake_currency }}
                                    </div>
                                </template>

                                <template v-slot:cell(reward_currency)="data">
                                    <div v-if="data.item.reward_currency">
                                        {{ data.item.reward_currency }}
                                    </div>
                                </template>
                                <template v-slot:cell(created_at)="data">
                                    <div v-if="data.item.created_at">
                                        {{ new Date(data.item.created_at).toLocaleDateString() }}
                                    </div>
                                </template>

                                <template v-slot:cell(maturity_days)="data">
                                    <div v-if="data.item.maturity_days" class="text-capitalize">
                                        {{ data.item.maturity_days }}
                                    </div>
                                </template>
                                <template v-slot:cell(plan_type)="data">
                                    <div v-if="data.item.plan_type">
                                        {{ data.item.plan_type }}
                                    </div>
                                </template>

                                <!-- Status section -->

                                <template v-slot:cell(activate_status)="data">
                                    <div class="text-center py-1 px-3 rounded fw-bold" :class="
                        data.item.activate_status == 1
                          ? 'bg-success'
                          : 'bg-warning'
                      ">
                                        {{ data.item.activate_status == 1 ? "ON" : "OFF" }}
                                    </div>
                                </template>

                                <template v-slot:cell(action)="data">
                                    <ul class="list-group list-group-horizontal">
                                        <li class="list-group-item bg-transparent border-0 pe-0">
                                            <span v-b-modal.modal-center @click="formOpen(data)">
                                                <i class="far fa-eye text-dark action"></i>
                                            </span>
                                        </li>
                                    </ul>
                                </template>
                            </b-table>
                        </div>
                        <div class="row m-0">
                            <div class="col p-0">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </simplebar>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal for assigning token to vendor -->
    <b-modal id="modal-center" size="xl" centered title="View Full Plan" title-class="font-18" hide-footer class="padding_modal" ref="vuemodal" @hidden="onHidden()">
        <b-form @submit="onSubmit($event, form.id)">
            <b-row>
                <b-col col lg="4">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">Title</label>
                        <input v-if="form.title" type="text" class="form-control" readonly v-model="form.title" />
                        <input v-else type="text" class="form-control" readonly  value="-"/>

                    </div>
                </b-col>

                <b-col col lg="4">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">Description</label>
                        <input v-if="form.description" type="text" class="form-control" readonly v-model="form.description" />
                        <input v-else type="text" class="form-control" readonly  value="-"/>

                    </div>
                </b-col>

                <b-col col lg="4">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">Stake Currency </label>
                        <input type="text" class="form-control" readonly v-model="form.stake_currency" />
                    </div>
                </b-col>

                <b-col col lg="4">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">Reward Currency</label>
                        <input type="text" class="form-control" readonly v-model="form.reward_currency" />
                    </div>
                </b-col>

                <b-col col lg="4">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">Maturity Days</label>
                        <input type="text" class="form-control" readonly v-model="form.maturity_days" />
                    </div>
                </b-col>

                <b-col col lg="4">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">Plan Type</label>
                        <input type="text" class="form-control" readonly v-model="form.plan_type" />
                    </div>
                </b-col>

                <b-col col lg="4">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">Max Stake Amount</label>
                        <input type="text" class="form-control" readonly v-model="form.max_stake_amount" />
                    </div>
                </b-col>

                <b-col col lg="4">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">Min Stake Amount</label>
                        <input type="text" class="form-control" readonly v-model="form.min_stake_amount" />
                    </div>
                </b-col>

                <b-col col lg="4">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">Plan Expiry Date</label>
                        <input v-if="form.plan_expiry_date" type="text" class="form-control" readonly v-model="form.plan_expiry_date" />
                        <input v-else type="text" class="form-control" readonly  value="-"/>
                    </div>
                </b-col>
                <b-col col lg="4">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">Plan Expiry Days</label>
                        <input type="text" class="form-control" readonly v-model="form.plan_expiry_days" />
                    </div>
                </b-col>
                <b-col col lg="4">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">Plan Start Date</label>
                        <input type="text" class="form-control" readonly v-model="form.plan_start_date" />
                    </div>
                </b-col>
                <b-col col lg="4">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">Pool Limit</label>
                        <input v-if="form.pool_limit" type="text" class="form-control" readonly v-model="form.pool_limit" />
                         <input v-else type="text" class="form-control" readonly  value="-"/>
                    </div>
                </b-col>
                <b-col col lg="4">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">ROI Interval</label>
                        <input type="text" class="form-control" readonly v-model="form.roi_interval" />
                    </div>
                </b-col>
                <b-col col lg="4">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">ROI Percentage</label>
                        <input type="text" class="form-control" readonly v-model="form.roi_percentage" />
                    </div>
                </b-col>
                <b-col col lg="4">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">Extra</label>
                        <input v-if="form.extra" type="text" class="form-control" readonly v-model="form.extra" value="-"/>
                         <input v-else type="text" class="form-control" readonly  value="-"/>
                    </div>
                </b-col>

                <!-- <b-col col lg="4">
            <div class="mb-3">
               <label for="exampleFormControlTextarea1" class="form-label">Select Priority</label>
              <input type="text" class="form-control" readonly v-model="form." />
            </div>
          </b-col> -->
                <hr />
                <h5>Activate Plan</h5>
                <b-col col lg="12">
                    <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label">Plan Status</label>
                        <multiselect v-model="plan_status" :options="selectStatus" label="name" track-by="name" placeholder="Choose..."></multiselect>
                        <span class="text-danger" v-if="!plan_status && submitted"> Status is required</span>
                    </div>
                </b-col>
                <div v-if="plan_status.value==1">
                    <span class="text-warning"><b>!Warning</b><br /> If It Once Activated Then Active Status Can't Be Changed</span>
                </div>
                <!---submit button-->
                <div class="col-12 mt-5 text-center">
                    <div class="form-group btn-submit">
                        <div class="spinner-border" role="status" v-if="this.formloading">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <button type="submit" class="btn btn-primary" id="submit" v-if="!formloading"> Submit </button>
                    </div>
                </div>
                <!---submit button-->

            </b-row>
        </b-form>
    </b-modal>

    <!-- end row -->
</Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import simplebar from "simplebar-vue";
import ApiClass from "../../api/api";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
export default {
    page: {
        title: "Staking List",
        meta: [{
            name: "description",
            content: appConfig.description,
        }, ],
    },
    components: {
        Layout,
        PageHeader,
        simplebar,
        Multiselect,
    },
    data() {
        return {
            title: "Staking List",
            items: [{
                    text: "Staking ",
                    // href: "/staking/list",
                },
                {
                    text: "Staking List",
                    active: true,
                },
            ],
            submitted: false,
            loading: false,
            formloading: false,
            selectStatus: [{name:"ON",value:1},{name:"OFF",value:0} ],
            form: {},
            totalRows: 0,
            currentRowData: "",
            currentPage: 1,
            perPage: 5,
            sortBy: "value",
            sortDesc: false,
            plan_status: {name:"OFF",value:0},
            fields: [
                "SR_NO",
                {
                    key: "title",
                    value: "title",
                    sortable: false,
                },
                {
                    key: "description",
                    value: "description",
                    sortable: false,
                },
                {
                    key: "stake_currency",
                    value: "stake_currency",
                    sortable: false,
                },
                {
                    key: "reward_currency",
                    value: "reward_currency",
                    sortable: false,
                },
                {
                    key: "created_at",
                    value: "created_at",
                    sortable: false,
                },
                {
                    key: "maturity_days",
                    value: "maturity_days",
                    sortable: false,
                },

                {
                    key: "plan_type",
                    value: "plan_type",
                    sortable: false,
                },
                {
                    key: "activate_status",
                    value: "activate_status",
                    sortable: false,
                },
                {
                    key: "action",
                    value: "action",
                    sortable: false,
                },
            ],
        };
    },
    methods: {
        onHidden() {
            this.$refs.table.refresh();
        },
        async formOpen(data){
            this.form = data.item;
          if(this.form.plan_expiry_date) {let expiry_date= parseInt(this.form.plan_expiry_date);
            var date = new Date(expiry_date);
            expiry_date = date.getDate()+"/"+(date.getMonth()+1)+"/"+date.getFullYear();
            this.form.plan_expiry_date=expiry_date;}


            if(this.form.plan_start_date){ let start_date= parseInt(this.form.plan_start_date);
            var date1 = new Date(start_date);
            start_date = date1.getDate()+"/"+(date1.getMonth()+1)+"/"+date1.getFullYear();
            this.form.plan_start_date = start_date;}

            this.plan_status = {value:this.form.activate_status,name:this.form.activate_status==0?"OFF":"ON"};
        },
        async onSubmit(event, id) {
            event.preventDefault();
            this.submitted = true;
            if (this.plan_status != null) {
                this.formloading = true;
                var param = {
                    "plan_id": id,
                    "plan_status": this.plan_status.value
                };

                var result = await ApiClass.updatenodeRequest("staking/activation", true, param);
                console.log("here=", result);

                if (result.data.status_code == "1") {
                    this.formloading = false;
                    this.submitted = false;
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: result.data.message,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    this.$refs.table.refresh();
                    this.$root.$emit("bv::hide::modal", "modal-center");
                } else {
                    this.formloading = false;
                    this.submitted = false;
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: result.data.message,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
            }
        },
        async myProvider(ctx, callback) {
            this.loading = !this.loading;
            await ApiClass.getNodeRequest("staking/get?all=true", true)
                .then((res) => {
                    // console.log('res=', res);

                    if (res.data.status_code == 1) {
                        this.loading = !this.loading;
                        const items = res.data.data ? res.data.data : [];
                        //this.currentPage = res.data.data ? res.data.data.current_page : '';
                        //this.totalRows = res.data.data ? res.data.data.total : '';

                        callback(items);
                    }
                })
                .bind(this);
        },
        onclose() {
            this.$root.$emit("bv::hide::modal", "modal-center");
        },
    },
};
</script>

<style scoped>
.action {
    font-weight: 600;
    cursor: pointer;
}

.add-btn-box {
    text-align: right;
}

.add-btn-box span.addbtn {
    background-color: #556ee6;
    color: #fff;
    padding: 10px 10px;
    border-radius: 5px;
    font-family: "Poppins";
    font-size: 13px;
    font-weight: 400;
}

/* .created_at {
  white-space: nowrap;
} */

.table> :not(caption)>*>* {
    white-space: break-spaces;
}

.form-control {
    border: none;
    border-bottom: 1px solid #ced4da;
    border-right: 1px solid #ced4da;
}

.table th {
    white-space: nowrap;
}


</style>
